<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <div>
        <h4 class="mb-2 fs-4">{{ title }}</h4>

        @if (subtitle) {
        <p class="text-muted">
          {{ subtitle }}
        </p>
        }
      </div>

      <div class="d-flex align-items-center gap-3">

        <ol class="breadcrumb m-0">
          @for(item of breadcrumbItems;track $index){
          @if(item.active){
          <li class="breadcrumb-item active">{{ item.label }}
          </li>
          }@else {
          <li class="breadcrumb-item"><a href="javascript: void(0);">{{ item.label }}</a>
          </li>
          }
          }
        </ol>

        @if (actionButton) {
        <button class="btn btn-primary" (click)="actionButton.onClick()">
          {{ actionButton.label }}
        </button>
        }
      </div>

    </div>
  </div>
</div>